import type { RouteId } from "$app/types";

/**
 * Whether a SvelteKit route id is `prefix` or nested under it. Matches whole
 * segments, so `/(dash)/apps` does not match `/(dash)/apps-archive`. Typing
 * `prefix` as `RouteId` makes `pnpm run check` fail when the route it names is
 * moved or deleted.
 */
export function isRouteUnder(
  routeId: string | null | undefined,
  prefix: RouteId,
): boolean {
  if (!routeId) return false;
  return routeId === prefix || routeId.startsWith(`${prefix}/`);
}

/** `isRouteUnder` for any of `prefixes`. */
export function isRouteUnderAny(
  routeId: string | null | undefined,
  prefixes: readonly RouteId[],
): boolean {
  return prefixes.some((prefix) => isRouteUnder(routeId, prefix));
}
